class DomHelper {

    /**
     * Retorna o primeiro elemento pai com scroll
     * @param  {element node} el Um elemento html presente na página
     * @return {object} É retornado o elemento com 
     */
    getScrollParent(node) {
      let regex = /(auto|scroll)/;

      let parents = function (node, ps) {
        if (node.parentNode === null) { return ps; }

        return parents(node.parentNode, ps.concat([node]));
      };

      let style = function (node, prop) {
        return getComputedStyle(node, null).getPropertyValue(prop);
      };

      let overflow = function (node) {
        return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
      };

      let scroll = function (node) {
       return regex.test(overflow(node));
      };

      let ps = parents(node.parentNode, []);

      if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
        return ;
      }

      for (let i = 0; i < ps.length; i += 1) {
        if (scroll(ps[i])) {
          return ps[i];
        }
      }

      return document.body;

      // let scrollParent = function (node) {
      //   if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
      //     return ;
      //   }

      //   let ps = parents(node.parentNode, []);

      //   for (let i = 0; i < ps.length; i += 1) {
      //     if (scroll(ps[i])) {
      //       return ps[i];
      //     }
      //   }

      //   return document.body;
      // };

      // return scrollParent;
    }

    /**
     * Retorna a posição de um elemento na página
     * @param  {element node} el Um elemento html presente na página
     * @return {object} É retornado um objeto com as posições do elemento dado
     */
    getElementPosition(el) {
        let pos = { top: 0, left: 0 };
        do {
            pos.top += el.offsetTop  || 0;
            pos.left += el.offsetLeft || 0;
            el = el.offsetParent;
        } while (el)
        pos.top -= window.scrollY;
        return pos;
    }
}

export default new DomHelper();
